"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shuffle = exports.removeElement = void 0;
const Random_1 = require("../../utils/Random");
function removeElement(array, value) {
    let i = 0;
    while (i < array.length) {
        if (array[i] === value) {
            array.splice(i, 1);
            continue;
        }
        i++;
    }
}
exports.removeElement = removeElement;
function shuffle(array) {
    const shuffled = [];
    let remaining = array.slice();
    while (remaining.length > 0) {
        const next = (0, Random_1.randomElement)(remaining);
        removeElement(remaining, next);
        shuffled.push(next);
    }
    return shuffled;
}
exports.shuffle = shuffle;
